var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQuotemarks = function SvgQuotemarks(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    fill: "none",
    viewBox: "0 0 19 19"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 2,
    d: "M6.93 11v7H1v-5.5c0-2.98.33-5.14 1-6.47A8.61 8.61 0 0 1 6.11 2l1.34 2.34A5.11 5.11 0 0 0 4.94 6.6c-.54 1-.84 2.46-.9 4.38h2.89Zm9.53 0v7h-5.92v-5.5c0-2.98.33-5.14.99-6.47A8.6 8.6 0 0 1 15.65 2L17 4.34a5.12 5.12 0 0 0-2.52 2.27c-.54 1-.84 2.46-.9 4.38h2.88Z",
    vectorEffect: "non-scaling-stroke"
  })));
};
export default SvgQuotemarks;